module.exports = __webpack_public_path__ + "img/bannerImg.8fa5769e.png";